import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { COLORS } from 'styleguide';

const LogoLink = styled(Link)`
  display: block;
  width: 100%;
  padding: 27px 0;
  background-color: ${COLORS.primary};
`;

export default LogoLink;
